import { LiveVideoPlayerElement } from '../../presets/live-video/player';
import { safeDefine } from '../../registration/safe-define';

safeDefine(LiveVideoPlayerElement);
